import i18n from 'services/base/i18n';

export default {
  // If there are no security issues, this text appears as the title of the page
  safeTitle: () => i18n.pgettext('Pages|Home', 'Safe'),

  // If there are no security issues, this text appears below "Safe"
  safeText: () => i18n.pgettext('Pages|Home', 'No new alerts'),

  // If the Pangolin is offline, this text appears as the title of the page
  offlineTitle: () => i18n.pgettext('Pages|Home', 'Offline'),

  // If the Pangolin is offline, this text appears below "Offline"
  offlineText: () => i18n.pgettext('Pages|Home', 'Your Pangolin is offline'),

  alertsText: (count: number) => i18n.sprintf(
    // If there are new security issues that the user has not seen, this appears
    i18n.npgettext('Pages|Home', '%d new alert', '%d new alerts', count),
    count,
  ),

  // If there are new security issues, this button appears that takes the user to the list of issues
  viewIssues: () => i18n.pgettext('Pages|Home', 'VIEW'),

  // Button to show the Pangolin selector modal
  modulePangolin: () => i18n.pgettext('Pages|Home', 'Pangolin'),

  // Link to the Intercept Tuning page
  moduleDeployment: () => i18n.pgettext('Pages|Home', 'Deployment'),

  // Link to the Plan Management page
  modulePlan: () => i18n.pgettext('Pages|Home', 'Plan'),

  // Link to the Update Management page
  moduleUpdate: () => i18n.pgettext('Pages|Home', 'Update'),

  // A link to Traffic History page
  moduleTrafficHistory: () => i18n.pgettext('Pages|Home', 'Traffic History'),

  // The description of the link to Traffic History page
  moduleTrafficHistoryLabel: () => i18n.pgettext('Pages|Home', 'View network activity'),

  // A link to the Bandwidth Prioritization page
  moduleBandwdithControls: () => i18n.pgettext('Pages|Home', 'Bandwidth Prioritization'),

  // The description of the link to Bandwidth Prioritization page
  moduleBandwdithControlsLabel: () => i18n.pgettext('Pages|Home', 'Allocate device bandwidth'),

  // A link to Parental Controls page
  moduleSchedules: () => i18n.pgettext('Pages|Home', 'Parental Controls'),

  // The description of the link to Parental Controls page
  moduleSchedulesLabel: () => i18n.pgettext('Pages|Home', 'Block and allow sites'),

  // A link to the VPN Server page
  moduleVPNServer: () => i18n.pgettext('Pages|Home', 'VPN Server'),

  // The description of the link to VPN Server page
  moduleVPNServerLabel: () => i18n.pgettext('Pages|Home', 'Configure remote access'),

  // Label above data showing the number of devices online
  devicesOnline: () => i18n.pgettext('Pages|Home', 'Devices Online'),

  // Label above data showing the number of trackers blocked
  trackersBlocked: () => i18n.pgettext('Pages|Home', 'Trackers Blocked'),

  // Label above data showing the number of threats blocked
  threatsBlocked: () => i18n.pgettext('Pages|Home', 'Threats Blocked'),

  // Label above data showing the number of flagged page loads
  totalQueries: () => i18n.pgettext('Pages|Home', 'Total Queries'),

  // Label above data showing the number of flagged page loads blocked
  blockedQueries: () => i18n.pgettext('Pages|Home', 'Queries Blocked'),

  // Label above data showing the percentage of page loads blocked
  percentBlockedQueries: () => i18n.pgettext('Pages|Home', 'Percent Blocked'),

  // If the user has no active firewall plan, inform them that they need a plan
  noPlanMessage: () => i18n.pgettext('Pages|Home', 'In order to fully use this Pangolin, you must purchase a **Pangolin Smart Firewall Plan**.'),

  // Text to display when the Pangolin has an expired plan
  planExpired: () => i18n.pgettext('Pages|Home|Plan Status', 'Expired'),

  // Text to display when the Pangolin has no plan
  planInactive: () => i18n.pgettext('Pages|Home|Plan Status', 'Inactive'),

  // Text to display when the Pangolin has an active upgrade
  updateUpgrade: () => i18n.pgettext('Pages|Home', 'Upgrading'),

  // Text to display when the Pangolin has an active restore
  updateRestore: () => i18n.pgettext('Pages|Home', 'Restoring'),

  // Text to display when the Pangolin has an update available
  updateAvailable: () => i18n.pgettext('Pages|Home', 'Available'),

  // Text to display when the Pangolin has the latest update
  updateLatest: () => i18n.pgettext('Pages|Home', 'Latest'),
};
